<template>
	<div
		class="flex flex-col items-stretch justify-between bg-white dark:bg-bs-dark-bg-over rounded-3xl mb-4 tip-item p-3 xl:p-5"
	>
		<div>
			<div class="grid grid-cols-tips grid-rows-tips my-3">
				<div class="score ml-auto ">
					<h3 class="gradient-text ">{{homeGoals}}</h3>
				</div>
				<svg
					width="21"
					height="44"
					viewBox="0 0 21 44"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="mx-auto top-5 relative"
				>
					<path
						d="M13.3841 12.8047L5.74067 24.3851H2.51489L0.264648 12.8047H3.62256L5.03007 20.3324L10.0091 12.8047H13.3841Z"
						fill="#BFC0C1"
					/>
					<path
						d="M10.7522 34.2487C9.89923 34.0173 9.20848 33.7195 8.68066 33.3553L10.0512 30.9065C10.6235 31.2817 11.2376 31.5658 11.8928 31.7589C12.5479 31.9519 13.2065 32.0484 13.8685 32.0484C14.4969 32.0484 14.9878 31.9574 15.3417 31.7753C15.6956 31.5932 15.8771 31.3426 15.888 31.0222C15.8969 30.747 15.747 30.5314 15.4375 30.3767C15.1281 30.2226 14.6455 30.057 13.9896 29.8804C13.2462 29.6818 12.6294 29.4805 12.1399 29.2765C11.6504 29.0725 11.2328 28.761 10.8885 28.3421C10.5434 27.9231 10.3825 27.3713 10.4051 26.6874C10.4325 25.8605 10.6824 25.1348 11.1548 24.5118C11.6271 23.8888 12.2884 23.4062 13.138 23.0639C13.9876 22.7223 14.9748 22.5511 16.0995 22.5511C16.9265 22.5511 17.696 22.6367 18.4073 22.8072C19.1186 22.9783 19.7279 23.2234 20.2358 23.5438L18.9645 25.9755C18.5216 25.6886 18.0301 25.4709 17.4886 25.3217C16.9477 25.1731 16.3898 25.0985 15.8168 25.0985C15.1658 25.0985 14.6523 25.2032 14.2765 25.4127C13.9 25.6222 13.7062 25.8926 13.696 26.2233C13.6864 26.5101 13.839 26.7306 14.1539 26.8853C14.4689 27.04 14.9597 27.205 15.6265 27.3816C16.37 27.5692 16.984 27.7622 17.4687 27.9608C17.9527 28.1593 18.3648 28.4626 18.7044 28.8706C19.044 29.2786 19.2028 29.8133 19.1809 30.4752C19.1542 31.292 18.9016 32.0115 18.4237 32.6344C17.9452 33.2574 17.2791 33.7401 16.424 34.0824C15.569 34.424 14.5845 34.5951 13.4707 34.5951C12.5109 34.5965 11.6045 34.4808 10.7522 34.2487Z"
						fill="#BFC0C1"
					/>
					<path
						d="M2.01885 43.8206C1.99352 43.8206 1.96751 43.8165 1.94286 43.8069C1.82922 43.7645 1.77513 43.6371 1.821 43.5228L18.9131 0.958548C18.959 0.843538 19.089 0.785347 19.202 0.827107C19.3156 0.869551 19.3697 0.996885 19.3239 1.11121L2.23107 43.6755C2.19547 43.7658 2.10921 43.8206 2.01885 43.8206Z"
						fill="#BFC0C1"
					/>
				</svg>
				<div class="score score-right">
					<h3 class="gradient-text">{{awayGoals}}</h3>
				</div>
				<div class="rounded-full mx-auto  w-9 h-9 flag-holder overflow-hidden">
					<img v-if="flag" :src="`/img/countries/${flag}.svg`" :alt="`Country ${country} Flag`"  />
					<img v-else :alt="`Country ${country}`" src="/img/countries/globe.svg"/>
				</div>
				<span
					class="text-xs 2xl:text-sm block text-bs-gray-dark dark:text-white font-medium text-right 3xl:text-xs"
					>{{ homeTeam }}</span
				>
				
				<div/>
				<span
						class="text-xs 2xl:text-sm block text-bs-gray-dark dark:text-white font-medium text-left 3xl:text-xs"
						>{{ awayTeam }}</span
					>
				<p class="date-text text-bs-gray-dark dark:text-white ">{{formatDate(createdDate)}}</p>
			</div>
			<div class="px-6 flex justify-between w-full border-t border-bs-gray-light pt-4 dark:border-bs-dark-bg">
				<span class="font-medium text-bs-gray-dark dark:text-white">Change</span>
				<span :class="[`status-${status.toLowerCase()}`,'text-right']">
					<h3 class="value main-value font-semibold">{{formatCurrency(outcome.total)}}</h3>
					<h5 class="value text-xs"><span class="">{{outcome.symbol}} </span> {{outcome.percent.toLocaleString('en-GB',{style:'percent'})}} </h5>
				</span>
			</div>
			<div class='px-4'>
				<svg  viewBox="0 0 200 50" :class="['line-chart', `line-status-${status.toLowerCase()}`]">
					<g >
						<path :d="area" class="area" :fill="`url(#gradient-mob-${status.toLowerCase()})`" />
						<path :d="line" fill="transparent" stroke-width="2" class="line"  stroke-linecap="round" />
						<circle r="4" :cx="circle.x - 2" :cy="circle.y - 2"   />
					</g>
					
					<defs>
						<linearGradient :id="`gradient-mob-${status.toLowerCase()}`" x1="0" x2="0" y1="0" y2="1">
							<stop class="stop1" offset="3%"/>
							<stop class="stop2" offset="60%"  />
						</linearGradient>
					</defs>
				</svg>
			</div>

			<div class="px-6 flex justify-between w-full border-t border-bs-gray-light pt-4 dark:border-bs-dark-bg">
				<span class="font-medium text-bs-gray-dark dark:text-white">Competition</span>
				<span
				class="text-base block text-bs-gray-dark dark:text-white text-right"
				>{{ competition }}</span
				>
			</div>
			
			<div class="px-6 flex justify-between w-full  pt-4">
				<span class="font-medium text-bs-gray-dark dark:text-white">Handicap</span>
				<span class="font-bold text-2xl gradient-text handicap">{{
					handicap
				}}</span>
			</div>
			<div class="px-6 flex justify-between w-full  pt-4">
				<span class="font-medium text-bs-gray-dark dark:text-white">Stake</span>
				<span class="font-bold text-2xl gradient-text handicap">{{
					formatCurrency(outcome.stake)
				}}</span>
			</div>
			<div class="px-6 flex justify-between w-full pt-3">
				<span class="font-medium text-bs-gray-dark dark:text-white">Odd</span>
				<span class="font-bold text-2xl gradient-text oddvalue">{{
					oddValue
				}}</span>
			</div>
		</div>
		
	</div>
</template>

<script>
import flags from '../../assets/flags.json'
import { mapGetters } from 'vuex';
import {scaleTime, scaleLinear, extent, line, area} from 'd3'
import { addDays, isBefore, format } from 'date-fns';
export default {
	props: [
		"id",
		"status",
		"homeTeam",
		"homeGoals",
		"awayTeam",
		"awayGoals",
		"statusLabel",
		"formattedDate",
		"statusClass",
		"country",
		"competition",
		"marketName",
		"handicap",
		"oddValue",
		"createdDate",
		"virtualTipAmount",
		"virtualEquityAfterTip"
	],
	data: function () {
		return {
			statuses: [
				{ label: 'Loss', 'key': 'is-loss' },
				{ label: 'Half Loss', 'key': 'is-half-loss' },
				{ label: 'Void', 'key': 'is-void' },
				{ label: 'Half Win', 'key': 'is-half-win' },
				{ label: 'Win', 'key': 'is-win' },
			]
		}
	},
	computed: {
		...mapGetters(['tipsByDate','equityByDate','settings']),
		line: function(){
			if (this.equityByDate) {
				let x = this.x()
				let y = this.y()
				const lineFn = line()
					.x((d) => { return x(d.x); })
					.y((d) => { return y(d.y); });
				let d = addDays(new Date(this.createdDate),1)
				return lineFn(this.equityByDate.filter(item => isBefore(item.x, d)));
			} else {
				return ''
			}
		},
		area: function(){
			if (this.equityByDate) {
				let x = this.x()
				let y = this.y()
				const lineFn = area()
					.x((d) => { return x(d.x); })
					.y0(() => y(0))
					.y1((d) => { return y(d.y); });
				let d = addDays(new Date(this.createdDate),1)
				return lineFn(this.equityByDate.filter(item => isBefore(item.x, d)));
			} else {
				return ''
			}
		},
		outcome: function(){
			let bucket = this.equityByDate.find(d => d.tipsOutcome[this.id])
			let outcome =  bucket.tipsOutcome[this.id]
			outcome.percent = outcome.value/outcome.total
			outcome.symbol =  outcome.value > 0  ? '▴' : outcome.value < 0 ? '▾' :'' 
			return outcome
				
		},
		circle: function(){
			if (this.outcome){
				let x = this.x()
				let y = this.y()
				return { x: x(new Date(this.createdDate)), y: y(this.outcome.total)}
			} else {
				return {x:0,y:0}
			}
		},
		flag : function(){
			if(this.country && flags[this.country.toLowerCase()]){
				return this.country.toLowerCase();
			} else {
				return false;
			}
		}
	},
	methods:{
		x: function(){
			return scaleTime()
				.domain(extent(this.equityByDate, d => new Date(d.x)))
				.range([5, (180)])
		},
		y: function(){
			return scaleLinear()
			.domain(extent(this.equityByDate, d => d.y))
			.range([45, 10])
		},
		formatCurrency: function (n) {
			
			return (
				typeof n !== "undefined" &&
				n.toLocaleString('en-GB', {
					style: "currency",
					currency: this.settings.currencyCode,
					currencyDisplay: "symbol",
				})
			);
		},
		formatDate: function(str){
			return format(new Date(str), 'dd-MM-yyyy HH:mm')
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";
.score {
	@apply relative flex items-center justify-center text-xl text-bs-yellow bg-bs-gray-light font-medium dark:bg-bs-dark-bg py-1 px-1 rounded w-12 h-10 text-center mb-1;
	border-top-left-radius: 1rem;
	border-bottom-right-radius: 1rem;

}
.score.score-right {
	border-top-left-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;
	border-top-right-radius: 1rem;
	border-bottom-left-radius: 1rem;
}
.score:after {
	content:'';
	position:absolute;
	top:50%;
	left:0;
	width:100%;
	height:1px;	
}
.score h3 {
	/* font-family: 'Orbitron', sans-serif; */
	@apply font-bold;
}
.flag-holder {
	position:relative;
	min-width: 3rem;
}
.flag-holder:after {
	position:absolute;
	width:100%;
	height:100%;
	content:'';
	top:0;
	left:0;
	border-radius: 100%;
	box-shadow: inset -37px 0px 0 -25px rgba(0,0,0,0.1)
}
.flag-holder img {
	width:100%;
	height:100%;
	z-index:-1;

}
.teams {
	display: grid;
	grid-template-columns: 1fr 60px 1fr;
	grid-template-rows: 50px 1fr;
	align-items:center;
	overflow:hidden;
}
.flag-and-teams {
	display:grid;
	grid-template-columns: 1fr 60px;

	width:100%;
	padding:0;
}
.tip-item {
	box-shadow: 0px 7px 14px #dde2ef;
}
.dark .tip-item {
	box-shadow: 0px 7px 14px rgba(0, 0, 0, 0.1);
}
.status {
	@apply text-xs px-2 m-1 py-3 text-bs-gray-dark whitespace-nowrap ;
	@screen lg {
		@apply px-3
	}
}
.selected-status {
	@apply text-white rounded-lg;
}
.is-win {
	background: linear-gradient(301.65deg, #1d9c2a 27.38%, #6be475 97.67%);
}

.is-loss {
	background: linear-gradient(294.18deg, #e50000 31.8%, #ffa7a7 109.71%);
}
.is-void {
	background: linear-gradient(303.37deg, #e5680c 27.95%, #fbd6bc 96.46%);
}
.is-half-win {
	background: linear-gradient(301.65deg, #87c88d 27.38%, #daffdd 97.67%);
}
.is-half-loss {
	background: linear-gradient(298.74deg, #fc6767 28.75%, #ffa7a7 102.13%);
}

@keyframes wobblebar-loader {
	0% {
		left: -60%;
	}
	100% {
    left: 100%;
  }
}
/* :not(:required) hides this rule from IE9 and below */
.is-pending:not(:required) {
	@apply  w-full;
	border-radius: 10.66667px;
	display: inline-block;
	overflow: hidden;
	text-indent: -9999px;
	
	height: 0.6rem;
	position: relative;
}
.is-pending:not(:required)::after {
  @apply bg-bs-yellow;
	animation: wobblebar-loader 1.2s infinite linear;
	display: block;
	-moz-border-radius: 7.11111px;
	-webkit-border-radius: 7.11111px;
	border-radius: 7.11111px;
	content: "";
	position: absolute;
	top: 0.1rem;
	left: 4px;
	width: 60%;
	height: 0.4rem;
}



.line-status-success  path.line {
  stroke: transparentize( $forest-green, 0.5);
  
}
#gradient-mob-success .stop1 {
	stop-color: transparentize( $forest-green, 0.8)
}
#gradient-mob-success .stop2 {
	stop-color: transparentize( $forest-green, 1)
}
.line-status-halfwin  path.line {
  stroke: transparentize( $forest-green-light, 0.5);
  
}
#gradient-mob-halfwin .stop1 {
	stop-color: transparentize( $forest-green, 0.9)
}
#gradient-mob-halfwin .stop2 {
	stop-color: transparentize( $forest-green, 1)
}
.line-status-void  path.line {
  stroke: transparentize( $orange, 0.5);
}
#gradient-mob-void .stop1 {
	stop-color: transparentize( $orange, 0.8)
}
#gradient-mob-void .stop2 {
	stop-color: transparentize( $orange, 1)
}
.line-status-halfloss  path.line {
  stroke: transparentize( $light-red, 0.5);
}
#gradient-mob-halfloss .stop1 {
	stop-color: transparentize( $light-red, 0.8)
}
#gradient-mob-halfloss .stop2 {
	stop-color: transparentize( $light-red, 1)
}
.line-status-fail  path.line {
  stroke: transparentize( $red-red, 0.5);
}
#gradient-mob-fail .stop1 {
	stop-color: transparentize( $red-red, 0.8)
}
#gradient-mob-fail .stop2 {
	stop-color: transparentize( $red-red, 1)
}


.line-status-success  circle, .status-success  .value {
  fill: $forest-green;
  color:  $forest-green;
  
  
}
.line-status-halfwin  circle, .status-halfwin  .value {
  fill: $forest-green-light;
  color:  $forest-green-light;
  
}
.line-status-void  circle, .status-void  .value {
  fill: $orange;
  color:  $orange;
  
}
.line-status-halfloss  circle, .status-halfloss  .value {
  fill: $light-red;
  color:  $light-red;
  
}
.line-status-fail  circle, .status-fail  .value {
  fill: $red-red;
  color:  $red-red;
}


.dark .status-success  .main-value {
  color: white;
  background: $forest-green;
  @apply rounded px-3;
  
}
.dark .status-halfwin  .main-value {
  color: white;
  background: $forest-green-light;
  @apply rounded px-3;
  
}
.dark .status-void  .main-value {
  color: white;
  background: $orange;
  @apply rounded px-3;
  
}
.dark .status-halfloss  .main-value {
  color: white;
  background: $light-red;
  @apply rounded px-3;
  
}
.dark .status-fail  .main-value {
  color: white;
  background: $red-red;
  @apply rounded px-3;
}
.dark .value {
  color:white;
}
</style>
